import React, { useState } from "react";

export default function Accordion({ data }) {
  const [openId, setOpenId] = useState(null);

  const toggleBlock = (id) => {
    setOpenId(openId === id ? null : id);
  };

  return (
    <div className="licenses__table">
      {data.map((block) => (
        <div key={block.id} className="licenses__blank">
          <h4 className="directions__more-title licenses__text">
            <li className="licenses__content">{block.title}</li>
          </h4>

          <button
            className="prevention__button news__button licenses__toggle-btn"
            onClick={() => toggleBlock(block.id)}
          >
            {openId === block.id ? "Скрыть файлы ▲" : "Показать файлы ▼"}
          </button>

          {openId === block.id && (
            <section>
              {block.files.map((file, index) => (
                <div key={index} className="licenses__blank-link">
                  <p className="development__text">{file.label}</p>
                  <a
                    href={file.path}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="structure__download-link licenses__link"
                  >
                    📄 Открыть PDF
                  </a>
                  <a
                    href={file.path}
                    download
                    className="structure__download-link licenses__link"
                  >
                    📥 Скачать PDF
                  </a>
                </div>
              ))}
            </section>
          )}
        </div>
      ))}
    </div>
  );
}
